module.exports = __webpack_public_path__ + "static/media/bancolombia.f6454538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/bancolombia.png
// module id = 1992
// module chunks = 0